<template>
  <div v-if="details">
    <Header :info="details.info" />
    <!-- todo: in progress-->
    <Body
      :details="details.data"
      :info="details.info"
    />
  </div>
</template>

<script>
import Header from './Header'
import Body from './Body'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    Header,
    Body
  },
  computed: {
    ...mapGetters({
      details: 'datalink/details'
    })
  },
  created () {
    this.fetchDetails(this.$route.params.id)
  },
  methods: {
    ...mapActions('datalink', [
      'fetchDetails'
    ])
  }
}
</script>
